/** Englische Texte zu den Cases, Bilder und Reihenfolge kommen aus cases-data.ts. */
export type EnCase = {
  industry: string;
  claim: string;
  situation: string[];
  work: string[];
  imageAlt: string;
};

export const enCases: Record<string, EnCase> = {
  deinlunu: {
    industry: "Food & confectionery",
    claim: "Strong candy brand, unclear path from landing to the right product",
    situation: [
      "Strong brand and good product photography, but the route from the homepage to the right product was longer than it needed to be.",
      "Bundles and volume discounts existed, yet only became visible late in the funnel.",
    ],
    work: [
      "Restructured the product page: value proposition, variants and bundle benefit above the fold",
      "Moved bundle and quantity logic to the point of decision instead of the cart",
      "Pulled trust elements (shipping, reviews, returns) next to the buy button",
      "Shortened mobile navigation and category entry",
    ],
    imageAlt: "LUNU Deluxe Collection product page on deinlunu.com",
  },
  gordigear: {
    industry: "Outdoor & roof tents (high ticket)",
    claim: "Explanation-heavy products with a long decision path",
    situation: [
      "High order values mean a long research phase, visitors returned several times before buying.",
      "Differences between tent models were not graspable at a glance.",
    ],
    work: [
      "Made model comparison visible (vehicle fit, size, use case)",
      "Addressed high-ticket objections: warranty, delivery time, payment options",
      "Rebuilt the product page around a decision instead of a feature list",
      "Reworked mobile galleries and technical specifications",
    ],
    imageAlt: "Homepage of the gordigear.de store",
  },
  maskabel: {
    industry: "Electrical & cables (B2C and B2B)",
    claim: "A configuration product: customers first have to find, then calculate",
    situation: [
      "Cables are bought by type, cores, cross-section and length, every uncertainty in the configurator costs a sale.",
      "Trade enquiries and private purchases ran down the same path.",
    ],
    work: [
      "Placed the cable finder on the homepage, selection in a few steps",
      "Made price and quantity logic (per metre, volume tiers) transparent at the point of selection",
      "Separated the bulk-quote path from the standard checkout",
      "Optimised mobile input fields and keyboard types for fast configuration",
    ],
    imageAlt: "Homepage of the maskabel.com store with cable finder",
  },
  "logo-matten": {
    industry: "Custom products / print on demand (B2B)",
    claim: "Custom-designed mats, the configurator decides the revenue",
    situation: [
      "Customers design the product themselves; drop-offs happen in the design and sizing step, not in checkout.",
      "Prices depend on size and quantity, which creates uncertainty.",
    ],
    work: [
      "Turned the design entry point into a clear step-by-step path",
      "Surfaced size and price logic earlier so fewer customers abandon the configurator",
      "Established a quote request as a second conversion for commercial volumes",
      "Placed trust anchors (delivery time, samples, invoice payment) at the decision point",
    ],
    imageAlt: "Homepage of the logo-matten.com store",
  },
  snydergolf: {
    industry: "Sports & golf equipment (CH)",
    claim: "Migration from WooCommerce to Shopify, plus personalisation as a revenue driver",
    situation: [
      "The store ran on WooCommerce: maintenance, plugin dependencies and load time stood in the way of selling.",
      "Revenue concentrates in a few months, in season every conversion point counts twice.",
      "Personalised balls carry high margins but were a side path instead of a main route.",
    ],
    work: [
      "Full migration from WooCommerce to Shopify: products, variants, customers and orders",
      "Preserved the URL structure with redirects so rankings and existing links survived",
      "Built personalisation into a visible, standalone buying path",
      "Reduced collection and product pages to a fast choice (ball model, quantity)",
      "Showed Swiss shipping and payment information early in the funnel",
    ],
    imageAlt: "Homepage of the snydergolf.ch store",
  },
  kremka: {
    industry: "Chemical-technical products (B2B)",
    claim: "B2B range with advisory needs and recurring orders",
    situation: [
      "Trade buyers usually know exactly what they need, they fail at finding, not at wanting.",
      "Consulting and shop stood next to each other instead of working together.",
    ],
    work: [
      "Made product overview and search the main entry point instead of image space",
      "Shortened reordering and quantity logic for existing customers",
      "Anchored the advice request directly at the products",
      "Improved mobile readability of technical data and datasheets",
    ],
    imageAlt: "Homepage of the kremka-shop.de store",
  },
};
